const shared = require('./shared');

module.exports = {
  authHeadersForAPI: shared.getAuthHeadersForAPI(),
  cookiesForDownstreamAPIs: shared.getCookiesForDownstreamAPIs(),
  B2BHeadersForAPI: shared.getB2BHeaders(),
  getHeadersForAPI() {
    const headers = shared.getCommonHeadersForAPI({ isServer: false });
    if (window.location.pathname.startsWith('/bassPV/')) {
      headers['x-content-preview'] = true;
    }
    return headers;
  }
};
